module.exports = __webpack_public_path__ + "static/speaking-image-1571174a34da89f4dbbb2fc2f3a92877.png";